var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.5,
    height: 54.712,
    viewBox: "0 0 55.5 54.712",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13901",
    "data-name": "Path 13901",
    d: "M56.25,20.4v2.509A6.231,6.231,0,0,1,52.974,28.4L35.035,38.057M2.25,20.4v2.509A6.231,6.231,0,0,0,5.526,28.4l17.939,9.659m24.477,6.951-12.9-6.951m0,0L32.2,36.534a6.231,6.231,0,0,0-5.91,0l-2.83,1.523m0,0L10.558,45.007M56.25,49.48a6.231,6.231,0,0,1-6.231,6.231H8.481A6.231,6.231,0,0,1,2.25,49.48V19.971a6.231,6.231,0,0,1,3.276-5.483L26.3,3.3a6.231,6.231,0,0,1,5.91,0L52.974,14.488a6.231,6.231,0,0,1,3.276,5.483V49.48Z",
    transform: "translate(-1.5 -1.748)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIcon);
export default __webpack_public_path__ + "static/media/MailIcon.f82798d847c60a3fa45c47adb8c5b4de.svg";
export { ForwardRef as ReactComponent };